// **********************************************************************
// ******** reset da senha do prestador ou do cliente ***
// ******** app/ResetSenha/resetsenha.jsx
// ******** autor: WdePaula / Microvolution
// ******** v1.0 data: 31/05/24 | 19h37
// ******** v1.1 data/hora: 8/7/26 | 16h50
// ******** 
// ********  reset da senha do prestador ou do cliente ***
// **********************************************************************





import React, { useState } from "react";
import { encryptPass } from "../../Services/cryptosenha";
import { Link, useNavigate } from 'react-router-dom';
import { useLocation } from "react-router-dom";
import { Oval } from 'react-loader-spinner';  // Import the loading spinner
import AgendexBrandLogo from '../../Assets/agendex/agendexLogoResponsivo'

import "./resetsenha.css";

const API_URL = process.env.REACT_APP_API_URL;
const BA_USERNAME = process.env.REACT_APP_BA_USERNAME;
// Use a senha ORIGINAL (sem criptografia) para Basic Auth:
// const BA_PASSWORD = process.env.REACT_APP_BA_PASSWORD; // SENHA ORIGINAL
// // const BA_PASSWORD = encryptPass(process.env.REACT_APP_BA_PASSWORD); // substituída a linha acima por esta 22/7/24w

function ResetPassword() {
    const ano = new Date().getFullYear();
    const navigate = useNavigate();

    const [emailreset, setEmailreset] = useState('');
    const [mensagem, setMensagem] = useState('');
    // const [tipoApp, setTipoApp] = useState(1); // 1 = Prestador default
    // const [colaborador, setColaborador] = useState(0); // 0 = Proprietário default
    // Captura o estado passado durante a navegação através do Link
    const location = useLocation();
    const { tipoApp: stateTipoApp, colaborador: stateColaborador } = location.state || {};

    // Inicializa o useState usando os valores recebidos do Link (ou usa o padrão/default caso acesse diretamente)
    const [tipoApp, setTipoApp] = useState(stateTipoApp !== undefined ? stateTipoApp : 1); 
    const [colaborador, setColaborador] = useState(stateColaborador !== undefined ? stateColaborador : 0);
    const [loading, setLoading] = useState(false);

    function generateValidationCode() {
        return Math.floor(100000 + Math.random() * 900000).toString();
    }

    async function ResetSenha() {
        if (!emailreset) {
            setMensagem('O e-mail não pode ficar em branco.');
            setTimeout(() => setMensagem(''), 7000);
            return;
        }

        setLoading(true);
        const rawPassword = process.env.REACT_APP_BA_PASSWORD || 'senha';
        const authString = btoa(`${BA_USERNAME}:${encryptPass(rawPassword)}`);

        let url;
        if (colaborador === 1) {
            url = new URL(`${API_URL}/usuario/ColaboradorContaExistente`);
        } else {
            url = new URL(`${API_URL}/usuario/ContaExistente`);
        }

        url.search = new URLSearchParams({
            email: emailreset,
            tipoApp: parseInt(tipoApp, 10)
        }).toString();

        try {
            const response = await fetch(url.toString(), {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Basic ${authString}`
                }
            });

            if (!response.ok) {
                const data = await response.json();
                throw new Error(data.retorno || 'Conta não localizada.');
            }

            const data = await response.json();
            const userName = data.nome;

            // Envia o código de validação
            const validationCode = generateValidationCode();
            const validationUrl = new URL(`${API_URL}/usuario/validaEmail`);
            validationUrl.search = new URLSearchParams({
                nome: userName,
                email: emailreset,
                codigo: validationCode
            }).toString();

            const validationResponse = await fetch(validationUrl.toString(), {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Basic ${authString}`
                }
            });

            if (!validationResponse.ok) {
                const validationData = await validationResponse.json();
                throw new Error(validationData.retorno || 'Erro ao enviar código de validação.');
            }

            // Redireciona com os dados necessários
            navigate('/app/resetsenha/cv', { 
                state: { 
                    email: emailreset, 
                    validationCode: validationCode, 
                    colaborador: colaborador 
                } 
            });

        } catch (error) {
            console.error('Fetch error:', error);
            if (error.message.includes('CORS policy')) {
                setMensagem('Erro de CORS. Verifique as configurações do servidor.');            
            } else if (error.message === 'Failed to fetch') {
                setMensagem('Erro de conexão. Verifique se o servidor Delphi está ativo.');            
            } else {
                setMensagem(error.message);
            }
            setTimeout(() => setMensagem(''), 7000);
        } finally {
            setLoading(false);
        }
    }

    return (
        <section id="resetsenha" className="py-5 d-flex align-items-center" style={{ minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
            <style>{`
                .fade-in { animation: fadeIn 0.4s ease-out forwards; }
                @keyframes fadeIn { from { opacity: 0; transform: translateY(15px); } to { opacity: 1; transform: translateY(0); } }
                .hover-scale { transition: transform 0.2s ease; }
                .hover-scale:hover { transform: scale(1.02); }
                .btn-primary-gradient { background: linear-gradient(145deg, #0d6efd, #0a58ca); border: none; }
                .btn-primary-gradient:hover { background: linear-gradient(145deg, #0b5ed7, #0a58ca); }
                .role-selector-card { border: 1px solid #dee2e6; border-radius: 12px; transition: all 0.2s ease; cursor: pointer; }
                .role-selector-card:hover { border-color: #0d6efd; background-color: #f8f9fa; }
                .role-selector-card.active { border-color: #0d6efd; background-color: rgba(13, 110, 253, 0.05); }
            `}</style>

            <div className="container" style={{ maxWidth: '540px' }}>
                <div className="card shadow-lg border-0 rounded-4 overflow-hidden fade-in">
                    
                    {/* Header decorativo da marca */}
                    <div className="bg-light p-4 text-center border-bottom d-flex justify-content-center">
                        <div className="bg-white px-3 py-2 rounded-3 shadow-sm">
                            <AgendexBrandLogo subtitle="RECUPERAÇÃO DE ACESSO" />
                        </div>
                    </div>

                    <div className="card-body p-4 p-md-5 position-relative">
                        {loading && (
                            <div className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-white bg-opacity-75" style={{ zIndex: 10 }}>
                                <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
                                    <span className="visually-hidden">Carregando...</span>
                                </div>
                            </div>
                        )}

                        <h3 className="fw-bold text-dark text-center mb-4">Esqueceu a Senha?</h3>
                        <p className="text-secondary text-center small mb-4">
                            Selecione o seu tipo de perfil, digite seu e-mail de acesso e nós lhe enviaremos um código de verificação de segurança.
                        </p>

                        <form onSubmit={(e) => e.preventDefault()}>
                            
                            {/* SELETOR DE PERFIL PREMIUM */}
                            <div className="mb-4">
                                <label className="form-label text-dark small fw-bold mb-2">Quem é você? (*)</label>
                                <div className="row g-2">
                                    <div className="col-4">
                                        <div 
                                            onClick={() => { setTipoApp(0); setColaborador(0); }}
                                            className={`p-2 text-center role-selector-card ${tipoApp === 0 ? 'active border-primary' : ''}`}
                                        >
                                            <div className="fw-bold small text-dark">Cliente</div>
                                        </div>
                                    </div>
                                    <div className="col-4">
                                        <div 
                                            onClick={() => { setTipoApp(1); setColaborador(0); }}
                                            className={`p-2 text-center role-selector-card ${tipoApp === 1 && colaborador === 0 ? 'active border-primary' : ''}`}
                                        >
                                            <div className="fw-bold small text-dark">Prestador</div>
                                        </div>
                                    </div>
                                    <div className="col-4">
                                        <div 
                                            onClick={() => { setTipoApp(1); setColaborador(1); }}
                                            className={`p-2 text-center role-selector-card ${colaborador === 1 ? 'active border-primary' : ''}`}
                                        >
                                            <div className="fw-bold small text-dark">Equipe</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* INPUT FLUTUANTE DE EMAIL */}
                            <div className="form-floating mb-4">
                                <input 
                                    type="email" 
                                    className="form-control" 
                                    id="emailusuario" 
                                    value={emailreset}
                                    onChange={(e) => setEmailreset(e.target.value)}
                                    placeholder="exemplo@agendex.com"
                                    style={{ borderRadius: '10px' }}
                                />
                                <label htmlFor="emailusuario">E-mail cadastrado (*)</label>
                            </div>

                            {mensagem && (
                                <div className="alert alert-danger py-2 rounded-3 text-center mb-4 fade-in small" role="alert">
                                    {mensagem}
                                </div>
                            )}

                            {/* BOTÃO SUBMIT */}
                            <div className="d-grid gap-2">
                                <button 
                                    type="button" 
                                    className="btn btn-primary-gradient btn-lg py-3 fw-bold rounded-3 shadow-sm hover-scale text-white"
                                    onClick={ResetSenha}
                                    disabled={loading}
                                >
                                    Enviar Código de Segurança
                                </button>
                            </div>

                        </form>
                    </div>

                    {/* RODAPÉ DO CARD */}
                    <div className="bg-light border-top p-4 text-center">
                        <div className="d-flex flex-column gap-2 small">
                            <Link to="/app/login" className="text-decoration-none text-primary fw-semibold">
                                Lembra suas credenciais? Toque para fazer login.
                            </Link>
                            <Link to="/app/novaconta" className="text-decoration-none text-secondary">
                                Não tem uma conta? Crie uma agora mesmo
                            </Link>
                        </div>
                    </div>

                </div>

                <div className="text-center mt-4 text-muted small">
                    <p>Desenvolvido por MVinfo Sistemas | WMX Group 2021 - {ano}</p>
                </div>
            </div>
        </section>
    );
}

export default ResetPassword;